/** Run work after first paint — analytics/monitoring should not block LCP. */
export function scheduleDeferred(task: () => void, timeoutMs = 3000): void {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(task, { timeout: timeoutMs });
    return;
  }
  // iOS Safari / WKWebView: no requestIdleCallback. Approximate "idle after paint"
  // with double rAF + a macrotask. Do not use a long setTimeout — that made below-fold
  // UI (and other deferred work) wait ~1.5s on iOS while Android's rIC ran promptly.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.setTimeout(task, 0);
    });
  });
}
